import { FiCheck } from "react-icons/fi";
import { STAGE_LABELS, STAGE_ORDER } from "../../utils/constants";
import { formatDate } from "../../utils/format";

export default function StageTracker({ stages = [] }) {
  const ordered = STAGE_ORDER.map((key) => stages.find((s) => s.key === key)).filter(Boolean);
  return (
    <ol className="stage-tracker">
      {ordered.map((stage, i) => (
        <li key={stage.key} className={`stage is-${stage.status === "done" ? "closed" : stage.status}`}>
          <span className="stage-marker" aria-hidden="true">
            {stage.status === "closed" || stage.status === "done" ? <FiCheck size={13} /> : i + 1}
          </span>
          <span className="stage-name">{STAGE_LABELS[stage.key]}</span>
          <span className="stage-dates">{formatDate(stage.startDate)} to {formatDate(stage.endDate)}</span>
          <span className="stage-status">{stage.status === "done" ? "Done" : stage.status === "open" ? "Open now" : stage.status === "closed" ? "Closed" : "Upcoming"}</span>
        </li>
      ))}
    </ol>
  );
}
